/**
 * Register the Tain PWA service worker.
 * Kept simple: only registers in production-like contexts (skips localhost dev to avoid caching stale bundles).
 */
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  const host = window.location.hostname;
  const isLocal = host === "localhost" || host === "127.0.0.1" || host.startsWith("192.168.");
  if (isLocal) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch((err) => {
        console.warn("SW registration failed", err);
      });
  });
}
